var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 52,
    viewBox: "0 0 23 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.86 5.45073C12.46 5.72073 9.54995 6.69072 7.27995 8.19072C5.06995 9.68072 3.35995 11.6407 2.18995 14.0807C1.53995 15.4307 0.859951 17.6007 0.739951 18.6907L0.699951 19.1907L5.65995 19.2307L10.64 19.2607L10.87 18.5207C11.79 15.7007 14.67 14.1507 18.19 14.5907C19.61 14.7607 20.61 15.2307 21.49 16.1107L22.12 16.8107L22.48 16.5507C21.73 15.0107 19.03 13.7007 16.33 13.9507C13.49 14.2207 11.5 15.5507 10.45 17.8807L10.09 18.6907H5.80995C3.43995 18.6907 1.39995 18.6507 1.38995 18.6407C1.36995 18.6507 1.81995 16.5007 2.20995 15.4507C3.85995 11.1107 7.68995 7.76074 12.47 6.51074C14.33 6.03074 16 5.73074 18.28 5.83074C19.43 5.87074 20.76 6.14073 21.27 6.25073C21.81 6.37073 22.07 6.44072 22.07 6.44072C22.07 6.44072 22.11 6.26074 22.12 6.16074C22.12 6.13074 22.14 6.07074 22.14 6.03074C22.14 6.02074 20.46 5.34074 17.92 5.31074C16.45 5.29074 15.08 5.41073 14.86 5.45073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.51 22.9703C20.66 24.2003 19.24 25.4804 9.96004 33.5104L1.11004 41.1703L1.07004 45.3104L1.04004 49.4703H11.58C19.66 49.4703 22.08 49.5103 22.13 49.5003C22.14 49.5003 22.13 49.2503 22.13 49.1903C22.13 49.1303 22.12 48.9304 22.12 48.9304C22.11 48.9304 19.77 48.9104 11.87 48.9104H1.61004V45.2203V41.5304L10.69 33.6903C20.54 25.1503 22.19 23.4704 22.35 22.5104C22.36 22.4604 22.06 22.3103 22.03 22.2903C22.01 22.2803 21.79 22.5803 21.51 22.9703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.39 37.5001C16.45 39.1001 14.69 40.5601 14.45 40.7601L14.02 41.1001H18.08C20.7 41.1001 22.13 41.1201 22.13 41.1201C22.14 41.1101 22.13 40.9001 22.13 40.8101C22.13 40.7101 22.13 40.5501 22.13 40.5501C22.11 40.5501 20.86 40.5201 18.95 40.5001L15.77 40.4601L18.78 37.9901C20.43 36.6301 22.02 35.3001 22.06 35.2501C22.07 35.2401 22.07 34.5701 22.06 34.5701C21.98 34.5901 20.33 35.9001 18.39 37.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_1378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 51.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.874c58bcc26480cb993390c1ea494ebd.svg";
export { ForwardRef as ReactComponent };